// src/Login.js - Thêm kiểm tra StudentContext an toàn
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { login } from './FirebaseService';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { StudentContext } from './StudentContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // 🌟 ĐỌC CONTEXT AN TOÀN: Kiểm tra nếu nằm ngoài StudentProvider thì gán null
  const studentContext = useContext(StudentContext);
  const refreshData = studentContext ? studentContext.refreshData : null;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && location.pathname === '/login' && localStorage.getItem('isLoggedIn')) {
        if (!window.redirecting) {
          window.redirecting = true;
          const role = localStorage.getItem('userRole') || 'catechist';
          navigate(role === 'admin' ? '/admin-management' : '/main', { replace: true });
        }
      }
    });

    const savedUsername = localStorage.getItem('rememberedUsername');
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }

    return () => {
      unsubscribe();
      window.redirecting = false;
    };
  }, [navigate, location]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMessage('Vui lòng nhập tên đăng nhập và mật khẩu');
      return;
    }

    setModalType('loading');
    setModalMessage('Đang đăng nhập...');
    setShowModal(true);

    try {
      const result = await login(username, password);
      if (result.success) {
        if (rememberMe) {
          localStorage.setItem('rememberedUsername', username);
        } else {
          localStorage.removeItem('rememberedUsername');
        }
        setErrorMessage('');
        setShowModal(false);

        // 🌟 CHỈ GỌI REFRESH KHI CONTEXT TỒN TẠI
        if (typeof refreshData === 'function') {
          refreshData();
        }

        const role = localStorage.getItem('userRole') || 'catechist';
        navigate(role === 'admin' ? '/admin-management' : '/main');
      } else {
        setErrorMessage(result.message);
        setModalType('error');
        setModalMessage(result.message);
      }
    } catch (error) {
      setErrorMessage(error.message || 'Đăng nhập thất bại. Vui lòng thử lại.');
      setModalType('error');
      setModalMessage(error.message || 'Đăng nhập thất bại. Vui lòng thử lại.');
    }
  };

  return (
    <div className="lglass-wrapper">
      <div className="lglass-blob lglass-blob-1"></div>
      <div className="lglass-blob lglass-blob-2"></div>
      <div className="lglass-blob lglass-blob-3"></div>

      <div className="lglass-card">
        <div className="lglass-header">
          <div className="lglass-logo-container">
            <img src="/logo.png" alt="Logo" className="lglass-logo" />
          </div>
          <h2 className="lglass-title">Đăng Nhập</h2>
          <p className="lglass-subtitle">Hệ thống Quản lý Giáo lý viên</p>
        </div>

        <form onSubmit={handleLogin} className="lglass-form">
          <div className="lglass-input-group">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Tên đăng nhập"
              required
              className="lglass-input"
            />
            <span className="lglass-input-highlight"></span>
          </div>

          <div className="lglass-input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mật khẩu"
              required
              className="lglass-input"
            />
            <span className="lglass-input-highlight"></span>
          </div>

          <div className="lglass-remember">
            <label className="lglass-checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="lglass-checkbox"
              />
              <span className="lglass-custom-checkbox"></span>
              <span className="lglass-remember-text">Ghi nhớ đăng nhập</span>
            </label>
          </div>

          <button
            type="submit"
            className="lglass-submit-btn"
            disabled={showModal && modalType === 'loading'}
          >
            <span>Đăng Nhập</span>
          </button>

          {errorMessage && <p className="lglass-error">{errorMessage}</p>}
        </form>
      </div>

      {showModal && (
        <div className={`lglass-modal-overlay ${modalType}`}>
          <div className="lglass-modal-card">
            {modalType === 'loading' && (
              <div className="lglass-spinner-container">
                <div className="lglass-spinner"></div>
              </div>
            )}
            <p className="lglass-modal-message">{modalMessage}</p>
            {modalType === 'error' && (
              <button onClick={handleCloseModal} className="lglass-modal-btn">
                Xác nhận
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;